import React from 'react'

function HousingProjects() {
  return (
    <div>HousingProjects</div>
  )
}

export default HousingProjects